import { createAction } from "@reduxjs/toolkit"
import { dialogSystemActions } from "./dialogSystem/slice"

export const resetReducerState = createAction("root/resetReducerState")

export default {
    ...dialogSystemActions
}
